import { instance } from "./core";

const orderSetCoupone = async (dataSend, errorHandler) => {
  return await instance.post("/checkcoupon", dataSend).catch(errorHandler);
};

export { orderSetCoupone };
